export default {
  ICON_WITH_TEXT: 1,
  ICON: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/main-action-style-types.js